var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSniperRifleVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.511 19.7775H114.99L114.441 19.2705H112.666L111.835 18.6795L110.541 18.9195L108.57 20.412H67.7727C67.7727 20.412 64.4967 19.476 64.2252 19.398C63.9537 19.32 48.5982 19.398 48.5982 19.398L46.8237 20.046L45.6942 19.596L45.2607 18.5115L46.3587 18.4695L46.7817 17.709L48.6822 18.1875L56.8752 18.0045L56.6502 14.415L47.9217 14.5845C47.9217 14.5845 46.4967 14.2695 46.1202 14.373C45.7437 14.4765 41.8407 14.19 41.8407 14.19L41.5032 13.5135H40.4082L39.7572 14.133H36.0972L34.7457 14.922H31.1982L31.3392 17.3295L32.4372 18.2445L35.0487 18.111L36.3222 18.639L36.6597 19.596L4.8147 19.7655L3.4917 20.835V31.7025L7.0962 34.743L18.4437 34.6725L19.2042 29.4495L17.5992 27.7185V25.5645L23.6532 25.29L24.3852 25.932L24.7197 27.3465L21.9642 33.8835L25.2867 35.658L25.9062 35.172L28.7922 29.0265L29.4672 28.266H32.8317L33.7332 29.0685L34.7472 28.7415L34.9587 34.1355L34.1562 34.9665V36.3315H46.5312V35.1705L45.8127 33.9675V28.6455L46.8687 28.815H57.9477L59.2992 29.1675L56.9202 31.7295H48.8952C48.2337 31.7295 48.6837 30.885 48.6837 30.885H47.8677L47.6277 33.504H57.9327L61.6917 29.5335L63.4992 29.565L64.5477 28.3485L75.1497 32.631L75.7692 33.2925L76.4727 33.543L77.1057 34.7415L78.3792 33.909L78.7977 33.1155L78.5112 31.4715L77.5422 31.8405L76.6692 31.5315H75.7677L70.4322 29.3925L70.5162 26.4495H75.3732L76.6677 26.8725H83.2287L83.6517 26.4075L86.7342 26.2815V24.702H83.6937V24.1275H76.6407L76.4712 24.702L70.4322 24.5505V23.9175H65.0967L67.6452 22.566H108.654L109.414 23.2425H117.058L117.777 22.056V20.709C117.777 20.709 116.679 19.7805 116.509 19.7805L116.511 19.7775ZM33.4782 27.252H29.1987V24.9225H33.4782V27.252ZM59.6907 23.7045V24.2955H47.3022L46.1202 23.394L46.5987 22.239L48.4857 23.2665H59.6922V23.703L59.6907 23.7045Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8259 20.2408V22.0573",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2263 19.7623V23.6203",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6846 19.7623V22.7758",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7322 20.2408V22.7758",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4675 20.2408V23.0293",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0408 14.5813V18.0028",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7468 14.9203V18.0028",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1211 14.3713V18.1723",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3875 14.5813V18.1858",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.739 15.5953H55.3985",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.739 16.8209H55.3985",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1121 15.2578H45.1356",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1121 16.2928H45.1356",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1121 17.3278H45.1356",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1121 18.3613H45.1356",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8349 34.2629L25.1599 33.5024L25.4974 32.5739H27.0184L27.3559 31.7713L26.4694 30.8428L26.7649 29.9459H28.2004L28.6654 28.6468L27.9904 27.7183L27.9484 25.8598C27.9484 25.8598 28.2154 25.3109 29.2009 25.3949",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.268 27.3463C36.9631 27.3463 37.5265 26.7829 37.5265 26.0878C37.5265 25.3928 36.9631 24.8293 36.268 24.8293C35.573 24.8293 35.0095 25.3928 35.0095 26.0878C35.0095 26.7829 35.573 27.3463 36.268 27.3463Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0496 33.8834H45.7701",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.28 35.1703V36.1423",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2312 35.1703V36.1423",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1804 35.1703V36.1423",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1313 35.1703V36.1423",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0811 35.1703V36.1423",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.032 35.1703V36.1423",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9812 35.1703V36.1423",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9324 35.1703V36.1423",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8116 30.7888C14.8116 30.3531 14.4587 29.9998 14.0234 29.9998C13.588 29.9998 13.2351 30.3531 13.2351 30.7888V32.5723C13.2351 33.0081 13.588 33.3613 14.0234 33.3613C14.4587 33.3613 14.8116 33.0081 14.8116 32.5723V30.7888Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4278 30.7889C17.4278 30.3531 17.0749 29.9999 16.6396 29.9999C16.2042 29.9999 15.8513 30.3531 15.8513 30.7889V32.5724C15.8513 33.0081 16.2042 33.3614 16.6396 33.3614C17.0749 33.3614 17.4278 33.0081 17.4278 32.5724V30.7889Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8792 23.0293H11.8837H7.12573",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8835 23.0294L13.8545 24.9224H23.9765",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8291 20.0444V21.8459",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29272 20.0443V21.8458",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7566 20.0443V21.8458",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81697 26.0878C4.95118 26.0878 5.05997 25.979 5.05997 25.8448C5.05997 25.7106 4.95118 25.6018 4.81697 25.6018C4.68277 25.6018 4.57397 25.7106 4.57397 25.8448C4.57397 25.979 4.68277 26.0878 4.81697 26.0878Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33651 26.0878C6.47071 26.0878 6.57951 25.979 6.57951 25.8448C6.57951 25.7106 6.47071 25.6018 6.33651 25.6018C6.2023 25.6018 6.09351 25.7106 6.09351 25.8448C6.09351 25.979 6.2023 26.0878 6.33651 26.0878Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82869 26.0878C7.9629 26.0878 8.07169 25.979 8.07169 25.8448C8.07169 25.7106 7.9629 25.6018 7.82869 25.6018C7.69449 25.6018 7.58569 25.7106 7.58569 25.8448C7.58569 25.979 7.69449 26.0878 7.82869 26.0878Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5605 28.4053C10.669 28.4053 10.757 28.3174 10.757 28.2088C10.757 28.1003 10.669 28.0123 10.5605 28.0123C10.452 28.0123 10.364 28.1003 10.364 28.2088C10.364 28.3174 10.452 28.4053 10.5605 28.4053Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2863 24.4363C25.3641 24.4363 25.4273 24.3732 25.4273 24.2953C25.4273 24.2174 25.3641 24.1543 25.2863 24.1543C25.2084 24.1543 25.1453 24.2174 25.1453 24.2953C25.1453 24.3732 25.2084 24.4363 25.2863 24.4363Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4406 24.4363C26.5184 24.4363 26.5816 24.3732 26.5816 24.2953C26.5816 24.2174 26.5184 24.1543 26.4406 24.1543C26.3627 24.1543 26.2996 24.2174 26.2996 24.2953C26.2996 24.3732 26.3627 24.4363 26.4406 24.4363Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5949 24.4363C27.6727 24.4363 27.7359 24.3732 27.7359 24.2953C27.7359 24.2174 27.6727 24.1543 27.5949 24.1543C27.517 24.1543 27.4539 24.2174 27.4539 24.2953C27.4539 24.3732 27.517 24.4363 27.5949 24.4363Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4346 24.5488V26.7178",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4734 24.7018V26.4493",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6929 23.8739C59.8624 23.8454 64.0459 23.8739 64.0459 23.8739",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6929 23.0293C59.6929 23.0293 59.9464 22.0573 60.6364 22.0573H63.2134C63.2134 22.0573 64.2274 21.9313 64.2274 23.0293",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7656 19.5944V23.0294",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7702 31.5314L75.3757 32.3204",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5431 31.8419L76.6716 33.4184",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63.76 26.7179L63.241 27.7169",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7068 29.5333H61.6928",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M108.318 20.4104V22.5644",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M109.079 20.1569H117.061",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M112.232 21.1138H110.543V22.0708H112.232V21.1138Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M115.103 21.1138H113.414V22.0708H115.103V21.1138Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M116.088 19.7773V22.9723",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5623 20.7058V22.2268",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5759 21.4873H107.178",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2527 28.773H63.8022L63.7602 29.5755L61.6902 29.4915L57.9312 33.504H47.6262V30.885H48.8937V31.7295H56.9187L58.9452 29.463C58.9452 29.463 59.2827 28.7445 58.2267 28.7445C57.1707 28.7445 46.8657 28.815 46.8657 28.815L45.8097 28.4355V33.9675L46.5282 34.7415V36.333H34.1532V34.77L34.9557 34.137V28.647L34.0272 29.07H33.1407L33.0987 28.2675H29.4672L28.7922 29.028L26.1312 35.2785L25.7082 35.7435L22.4142 34.35C22.4142 34.35 21.9912 34.0125 22.2882 33.21C22.5852 32.4075 24.6957 27.72 24.6957 27.72L24.7797 26.4525L23.9772 25.3965L17.5992 25.566V27.72L19.2042 29.451V34.7445H7.0962L3.4917 31.704V20.8365L4.5057 19.767H36.0402L36.7722 19.2045C36.7722 19.2045 37.0542 18.6975 36.3222 18.642L35.4777 18.2475H32.4372L31.8747 17.5155H31.1427L31.1997 14.925H35.1417L36.0987 14.136H40.1532V13.5165H41.8422V14.1915H46.2342C46.2342 14.1915 46.8537 14.4165 47.5287 14.4165H56.8767V18.189H48.4302L46.7832 17.7105L46.3602 18.471L45.2622 18.513L45.7692 19.7805L46.7412 19.8645L46.8252 20.244L48.5997 19.3995H64.2267L67.7742 20.4135H108.573L109.08 20.16V19.569L109.966 19.527L110.515 18.6825H112.12L112.669 19.2735H114.444L114.993 19.7805H117.063V20.3715H117.781V22.4415H117.148V23.244H109.419L108.658 22.569H67.6467L63.9297 23.9205H70.4337V24.7065H76.4727L76.6422 24.132H83.6952V24.7065H86.7357V26.286L83.6532 26.412V26.877H76.4307L76.5147 26.454H70.5177V28.7775H68.8857",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1707 25.338L61.0722 25.62C61.0722 25.62 61.6077 25.4235 62.1147 25.62C62.6217 25.8165 62.7057 26.295 62.7057 26.295L75.7707 31.5315H76.6722L77.5452 31.8405C77.5452 31.8405 79.0092 31.1085 78.8967 31.644C78.7842 32.1795 78.8967 33.1365 78.7002 33.558C78.5037 33.9795 77.1087 34.74 77.1087 34.74C77.1087 34.74 76.7007 33.951 76.7847 33.783C76.8687 33.615 75.7707 33.291 75.7707 33.291L75.1512 32.6295L62.2557 27.42C62.2557 27.42 61.7202 27.645 61.1292 27.3915C60.5382 27.138 60.4257 26.463 60.4257 26.463L59.6367 26.0685C59.6367 26.0685 59.2707 25.0545 60.1722 25.3365L60.1707 25.338Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6929 23.7045V24.2955H47.3043L46.1208 23.3955L46.5993 22.2405L48.4863 23.268H59.6929V23.7045Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9568 28.6455H45.8108",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0408 19.7625H45.7698",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47729 19.7625V23.268H7.49129V24.702L12.1083 27.1395V34.7415",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9753 25.3935V23.0295H46.1198",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1987 24.9225H31.3392H33.4782V27.252H29.1987V24.9225Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6627 27.252L31.3392 24.9225H29.1987V27.252H30.6627Z",
    fill: "#FAFAFB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2559 25.2885C57.2559 25.2885 57.3399 26.619 58.0164 26.661C58.6929 26.703 58.9029 26.661 58.9029 26.661V27.717H49.0209L48.0924 27.084L41.8419 27.042L41.1234 27.717H39.6459L39.2229 27.252V25.8585C39.2229 25.8585 39.1809 25.2885 39.8979 25.2885H57.2559V25.2885Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6921 23.0295V13.188",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSniperRifleVariant);
export default __webpack_public_path__ + "static/media/Sniper Rifle Variant.d9d262c89f090115f8a593b9b9a54ca7.svg";
export { ForwardRef as ReactComponent };